import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["avatar", "input", "filename", "removeInput", "clear"];

  connect() {
    // Bind escape key handler
    // Note: handleKeydown method doesn't exist in this controller
    // document.addEventListener("keydown", this.handleKeydown);
  }

  disconnect() {
    // Clean up event listeners if needed
  }

  triggerFileInput(event) {
    // Prevent triggering when clicking on the clear button
    if (event.target.closest('[data-action*="clear"]')) {
      return;
    }
    
    // Find the file input within this controller's element
    this.inputTarget.click();
  }

  handleFileSelect(event) {
    const file = event.target.files[0];

    if (!file) {
      console.log("No file selected");
      return;
    }

    if (!file.type.startsWith("image/")) {
      console.log("Not an image file", file.type);
      return;
    }

    const reader = new FileReader();

    reader.onload = (e) => {
      const img = document.createElement("img");
      img.src = e.target.result;
      img.className = "w-full h-full object-cover shadow-md z-[2]";

      // Clear existing image and add the new one
      const existingImg = this.avatarTarget.querySelector("img.z-\\[2\\]");
      if (existingImg) {
        existingImg.remove();
      }
      this.avatarTarget.appendChild(img);
      this.filenameTarget.innerText = file.name;
      this.clearTarget.classList.remove("hidden");
    };

    reader.readAsDataURL(file);
    this.removeInputTarget.value = 0;

    const removeInputName = this.removeInputTarget.name;
  }

  clear(e) {
    e.preventDefault();
    const text = this.clearTarget.dataset.confirmText;
    if (confirm(text)) {
      const img = this.avatarTarget.querySelector("img");
      if (img) {
        img.remove();
        this.filenameTarget.innerText = this.filenameTarget.dataset.defaultText;
      }
      this.clearTarget.classList.add("hidden");
      this.removeInputTarget.value = 1;
      this.updateTimestamp();
    }
  }

  updateTimestamp() {
    // Get the original input name
    const removeInputName = this.removeInputTarget.name;

    // Transform the name to replace the last bracket content with updated_at
    const updatedAtName = removeInputName.replace(
      /\[[^\]]+\]$/,
      "[updated_at]",
    );

    // Remove existing timestamp input if it exists
    const existingTimestamp = this.removeInputTarget.nextElementSibling;
    if (existingTimestamp?.getAttribute("name") === updatedAtName) {
      existingTimestamp.remove();
    }

    // Create and insert new timestamp input
    const timestampInput = document.createElement("input");
    timestampInput.type = "hidden";
    timestampInput.name = updatedAtName;
    timestampInput.value = new Date().toISOString();

    // Insert after removeInput
    this.removeInputTarget.insertAdjacentElement("afterend", timestampInput);
  }
}
